import PostHogPageViewTracker from "./PostHogViewTracker";

const withPostHogTracker = (Component: JSX.Element) => (
  <>
    <PostHogPageViewTracker />
    {Component}
  </>
);

export default withPostHogTracker;